import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaTimes, FaExclamationCircle, FaCheckCircle } from 'react-icons/fa';
import CustomButton from '../CustomButton';
import { showToast } from '../Toast/toast';
import './BoostProfileModal.css';

const BoostProfileModal = ({ show, onHide }) => {
  const [step, setStep] = useState(1); // 1: Confirmation, 2: Success
  const [boosting, setBoosting] = useState(false);

  const handleConfirm = async () => {
    try {
      setBoosting(true);

      // TODO: Add API call here when API is ready
      // const response = await boostProfile();
      // if (response.status) {
      //   setStep(2);
      // } else {
      //   showToast(response.message || 'Failed to boost profile', 'error');
      // }

      // Simulate API call for now
      setTimeout(() => {
        setStep(2);
        setBoosting(false);
      }, 500);
    } catch (error) {
      console.error('Error boosting profile:', error);
      showToast(error.message || 'Failed to boost profile', 'error');
      setBoosting(false);
    }
  };

  const handleCancel = () => {
    setStep(1);
    onHide();
  };

  const handleSuccessClose = () => {
    setStep(1);
    onHide();
  };

  const renderConfirmationStep = () => (
    <div className="boost-modal-content">
      <div className="boost-icon-wrapper">
        <FaExclamationCircle className="boost-icon" />
      </div>
      <p className="boost-modal-message">
        Boost profile helps you elevate your profile to the top. If you click on Boost, it will be applied to your profile. Do you want to boost it now?
      </p>
      <div className="boost-modal-buttons">
        <CustomButton
          onClick={handleConfirm}
          disabled={boosting}
          className="boost-yes-btn"
        >
          {boosting ? 'Boosting...' : 'Yes'}
        </CustomButton>
        <CustomButton
          onClick={handleCancel}
          variant="secondary"
          className="secondaryButton"
        >
          No
        </CustomButton>
      </div>
    </div>
  );

  const renderSuccessStep = () => (
    <div className="boost-modal-content">
      <div className="success-icon-wrapper">
        <FaCheckCircle className="success-icon" />
      </div>
      <h4 className="boost-modal-title">Successful Boost</h4>
      <p className="success-message">
        Your profile is now on Boost!
      </p>
      <div className="boost-form-buttons">
        <CustomButton
          onClick={handleSuccessClose}
          className="boost-ok-btn"
        >
          Ok
        </CustomButton>
      </div>
    </div>
  );

  return (
    <Modal show={show} onHide={handleCancel} centered className="boost-profile-modal">
      <Modal.Body className="boost-modal-body">
        <button className="modal-close-btn" onClick={handleCancel}>
          <FaTimes />
        </button>

        {step === 1 && renderConfirmationStep()}
        {step === 2 && renderSuccessStep()}
      </Modal.Body>
    </Modal>
  );
};

export default BoostProfileModal;

